import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import CommonBankLogo from "../../../_utils/CommonBankLogo";
import ListContainer from "../../../_utils/CommonListView/ListContainer";
import ListTextWithIcon from "../../../_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import TickerAnimation from "../../../_utils/TickerAnimation";
import { useSelector } from "react-redux";

const InternalAccountListView = ({
  id,
  data,
  isSidebarOpen,
  isPopoverOpen,
  typepop,
  handleButtonClick,
  internalAccount,
  associateAccount,
  showSearchBar,
  beneAccountId,
  txnPayLoad,
  setTxnPayLoad,
  setIsNeft,
  setIsRtgs,
  setIsImps,
  flow,
  accountType,
  setOpenBeneAssociate,
  scheduleIntenralTxn,
  isLabelClicked,
  LabelAccounts,
  handleLabelSelect,
  setlableInput,
  filterRef,
  onCardNavigate,
}) => {
  const navigate = useNavigate();
  const { services } = useSelector((state) => state.refreshToken);
  const location = useLocation();
  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  const listdata = data || [];

  return (
    <>
      <div
        className={`standard-list-view-alignment ${
          listdata.filter((item) => item.id !== beneAccountId).length ===
            GlobalConfiguration.lengthCheckZero && "flex-1"
        }`}
        style={{
          display:
            listdata.filter((item) => item.id !== beneAccountId).length ===
            GlobalConfiguration.lengthCheckZero
              ? "flex"
              : "grid",
        }}
      >
        {listdata?.filter((item) => item.id !== beneAccountId).length >
          GlobalConfiguration.lengthCheckZero &&
          listdata
            ?.filter((item) => item.id !== beneAccountId)
            .map((item, index) => {
              return (
                <ListContainer
                  hoverHeight={
                    GlobalConfiguration.internalAccountListHoverHeight
                  }
                  filterRef={filterRef}
                  key={item.id}
                  isSelected={
                    Array.isArray(LabelAccounts) &&
                    LabelAccounts?.some((account) => account?.id === item?.id)
                  }
                  isDisabled={
                    item.id === id ||
                    (typepop === "popup" &&
                      !associateAccount &&
                      (item?.approval_status === "blocked" ||
                        item?.approval_status === "archived" ||
                        item?.approval_status === "rejected")) ||
                    (typepop === "popup" &&
                      item?.approval_status !== "blocked" &&
                      item?.approval_status !== "archived" &&
                      item?.approval_status !== "rejected" &&
                      internalAccount === "internalAccount" &&
                      txnPayLoad?.ownerBankAccountNo === item?.bank_acc_no &&
                      txnPayLoad?.ownerBankIFSC === item?.ifsc_code &&
                      txnPayLoad?.ownerPan === item?.pan_no)
                  }
                  context={item}
                  onClickHandler={async () => {
                    if (
                      typepop === "popup" &&
                      (item?.approval_status === "blocked" ||
                        item?.approval_status === "archived" ||
                        item?.approval_status === "rejected") &&
                      !associateAccount
                    ) {
                      return;
                    } else if (typepop === "popup" && !associateAccount) {
                      if (isLabelClicked) {
                        handleLabelSelect?.(item);
                        setlableInput(false);
                      } else {
                        handleButtonClick(item);
                      }
                    } else {
                      if (!isLabelClicked) {
                        let selection = window.getSelection();
                        if (
                          selection.toString().length ===
                          GlobalConfiguration.lengthCheckZero
                        ) {
                          if (!isSidebarOpen) {
                            const redirectUrl = `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${item.id}`;
                            if (onCardNavigate) {
                              onCardNavigate(redirectUrl);
                              return;
                            }
                            if (associateAccount) {
                              setOpenBeneAssociate(false);
                            }
                            navigate(redirectUrl, {
                              state: {
                                isViewAll:
                                  location.pathname ===
                                  "/internal_account_dashboard/internal_account_view_all"
                                    ? true
                                    : false,
                              },
                            });
                          }
                        }
                      } else {
                        handleLabelSelect?.(item);
                        setlableInput(false);
                      }
                    }
                  }}
                >
                  <list-body>
                    <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                      <div className="flex flex-col gap-y-gap-sm w-full">
                        <div className="w-full flex gap-x-gap-sm">
                          <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                            <CommonBankLogo
                              variant="small"
                              ifsc={item.ifsc_code}
                            />
                          </div>
                          <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                            <TickerAnimation
                              text={standardAccountNumberFormat(
                                item?.bank_acc_no,
                                true,
                              )}
                            />
                          </p>
                          <div className="border-l border-primary-bg"></div>
                          <div className="flex gap-x-gap-sm justify-end items-center">
                            <p
                              style={{
                                color: getStatusColor(item?.approval_status),
                              }}
                              className="text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right"
                            >
                              {services?.includes("IAAccount") &&
                              item?.approval_status === "pending"
                                ? "Require approval"
                                : item?.approval_status || "N/A"}
                            </p>

                            <img
                              style={{
                                display: isLabelClicked ? "flex" : "none",
                              }}
                              className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                              src={
                                Array.isArray(LabelAccounts) &&
                                LabelAccounts?.some(
                                  (account) => account?.id === item?.id,
                                )
                                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                  : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                              }
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="w-full pl-padding-sm flex justify-between items-center relative">
                          <p className="text-font-xs text-text-primary flex-1 truncate font-normal">
                            <TickerAnimation text={item?.name} />
                          </p>
                        </div>
                      </div>
                    </div>
                  </list-body>
                  <list-hover>
                    <ListTextWithIcon
                      type={"text"}
                      text={item?.labels?.join(", ") || "No labels assigned "}
                      iconComponentArray={[{ icon: ICONS?.LABEL }]}
                    />
                  </list-hover>
                </ListContainer>
              );
            })}
      </div>
    </>
  );
};

export default InternalAccountListView;
